import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, Home, Search } from 'lucide-react';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center px-4"
         style={{ background: 'var(--surface-1)' }}>
      <div className="text-center max-w-md w-full">

        {/* 404 number */}
        <div className="relative mb-6 select-none">
          <p className="font-display font-black leading-none"
             style={{ fontSize: 'clamp(100px, 20vw, 160px)', color: 'var(--border-c)' }}>
            404
          </p>
          {/* Logo overlay */}
          <div className="absolute inset-0 flex items-center justify-center">
            <img src="/logo.png" alt="FNB HUB"
                 className="h-20 w-20 rounded-2xl object-cover shadow-xl opacity-90" />
          </div>
        </div>

        {/* Message */}
        <h1 className="font-display font-black text-2xl mb-2" style={{ color: 'var(--text-1)' }}>
          Trang không tồn tại
        </h1>
        <p className="text-sm mb-8 leading-relaxed" style={{ color: 'var(--text-3)' }}>
          Đường dẫn bạn truy cập không tồn tại hoặc đã bị xóa.
          <br />Hãy kiểm tra lại URL hoặc quay về trang chủ.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl border text-sm font-medium transition-all hover:border-orange-400 hover:text-orange-500"
            style={{ borderColor: 'var(--border-c)', color: 'var(--text-2)' }}
          >
            <ArrowLeft size={15} /> Quay lại
          </button>

          <Link to="/"
            className="btn-brand flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold">
            <Home size={15} /> Trang chủ
          </Link>

          <Link to="/sang-nhuong"
            className="flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl border text-sm font-medium transition-all hover:border-orange-400 hover:text-orange-500"
            style={{ borderColor: 'var(--border-c)', color: 'var(--text-2)' }}
          >
            <Search size={15} /> Tìm kiếm
          </Link>
        </div>

        {/* FNB HUB brand */}
        <p className="mt-10 text-xs" style={{ color: 'var(--text-3)' }}>
          © 2025 <span style={{ color: 'var(--brand)' }} className="font-semibold">FNB HUB</span> — Nền tảng F&B hàng đầu Việt Nam
        </p>
      </div>
    </div>
  );
}
